// extracted by mini-css-extract-plugin
export var menuIcon = "_sg-0";
export var menuIconInline = "_sg-1";